import { useState, useEffect } from "react";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 3 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";

// EditProduct project components
import ProductImage from "./components/ProductImage";
import Price from "./components/Price";
import MainInfo from "./components/MainInfo";
import LangForm from "./components/LangForm";

import crudsService from "services/cruds-service";
import i18n from "i18n";
import prepareNewArr from "helper/prepareNewArr";
import deepDiff from "helper/deep-diff";
import getEmptyFields from "helper/getEmptyFields";
import { icon } from "@fortawesome/fontawesome-svg-core";
import { it } from "date-fns/locale";
import MDAlert from "components/MDAlert";
import { useNavigate, useParams } from "react-router-dom";

function EditProject() {
  const { t } = i18n;
  const baseUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();

  const { id } = useParams();
  const [donationDefaultValues, setDonationDefaultValues] = useState([]);
  const [project, setProject] = useState({
    id: null,
    category: null,
    cost: 0,
    donation_default_value: 0,
    donation_default_rate: 0,
    benficial_num: 0,
    impl_country_id: null,
    period: "",
    status: "draft",
    zakaat_available: false,
    urgent: false,
    all_amount_required: false,
    target_segments: [],
    categories: [],
    tags: [],
    faqs: [],
    lisence: "",
    slug: "",
    sequence: 0,
    status_id: null,
    period_type: null,
    name: "",
    pic: null,
    summary: "",
    desc: "",
    promo_video_url: "",
    targets: "",
    timeline: "",
    report_file: null,
    translations: {},
    donation_begin_from: 0,
    num_of_donors_begin_from: 0,
    date_begin: null,
    date_end: null,
    donation_default_values: "10__50__100",
  });
  const [info, setInfo] = useState({
    id: null,
    category: {},
    cost: 0,
    donation_default_value: 0,
    donation_default_rate: 0,
    benficial_num: 0,
    impl_country_id: {},
    period: "",
    status: "draft",
    zakaat_available: false,
    urgent: false,
    all_amount_required: false,
    target_segments: [],
    categories: [],
    tags: [],
    faqs: [],
    lisence: "",
    slug: "",
    sequence: 0,
    status_id: null,
    period_type: null,
    name: "",
    summary: "",
    desc: "",
    promo_video_url: "",
    targets: "",
    timeline: "",
    report_file: null,
    translations: {},
    donation_begin_from: 0,
    num_of_donors_begin_from: 0,
    date_begin: null,
    web_pic: null,
    date_end: null,
    donation_default_values: "10__50__100",
  });
  const [linfo, setLInfo] = useState({
    translations: {},
  });
  const [categories, setCategories] = useState([]);
  const [tags, setTags] = useState([]);
  const [faqs, setFaqs] = useState([]);
  const [allStatus, setAllStatus] = useState([]);
  const [countries, setCountries] = useState([]);
  const [targetSegments, setTargetSegments] = useState([]);

  const [notification, setNotification] = useState({
    value: false,
    color: "info",
    message: "",
  });

  const [errors, setErrors] = useState({
    cost: false,
    donation_default_value: false,
    donation_default_rate: false,
    benficial_num: false,
    period: false,
    lisence: false,
    slug: false,
    sequence: false,
    impl_country_id: false,
    status_id: false,
    period_type: false,
    target_segments: false,
    categories: false,
    faqs: false,
    web_pic: false,
    pic: false,
    translations: {
      name: false,
      summary: false,
      desc: false,
      promo_video_url: false,
      report_file: false,
      targets: false,
      timeline: false,
    },
  });

  const chkErrors = {
    cost: false,
    donation_default_value: false,
    donation_default_rate: false,
    benficial_num: false,
    lisence: false,
    slug: false,
    status_id: false,
    categories: false,
    faqs: false,
    web_pic: false,
    translations: {
      name: false,
      summary: false,
      desc: false,
      promo_video_url: false,
      targets: false,
      pic: false,
    },
  };

  const periodTypes = [
    { name: t("day"), id: "day" },
    { name: t("month"), id: "month" },
    { name: t("year"), id: "year" },
  ];

  const many2manyPrepareNewArr = (arr, name, objKey) => {
    let newArr = [];
    for (const key in arr) {
      if (Object.hasOwnProperty.call(arr, key)) {
        const element = arr[key][name];
        newArr.push({
          id: element?.id,
          name: element?.translations[0][objKey || "name"],
        });
      }
    }
    return newArr;
  };

  const getProjects = async () => {
    // const response = await crudsService.getProjectById(id);
    const response = await crudsService.getAllData(
      `items/projects/${id}?fields=*,translations.report_file,translations.timeline,translations.pic,translations.name,translations.summary,translations.desc,translations.promo_video_url,translations.targets,translations.languages_code.name,translations.languages_code.code,target_segments.id,target_segments.target_segment_id.id,target_segments.target_segment_id.translations.*,impl_country_id.translations.name,impl_country_id.id,status_id.id,status_id.translations.name,status_id.color,categories.categories_id.id,categories.categories_id.translations.*,tags.id,tags.tags_id.id,tags.tags_id.translations.*,faqs.id,faqs.faq_id.id,faqs.faq_id.translations.*`,
    );

    let tSegments = [];

    many2manyPrepareNewArr(
      response.data.target_segments,
      "target_segment_id",
    ).forEach((targetSegmentItem) => {
      tSegments.push(targetSegmentItem);
    });

    let categoriesArr = [];

    many2manyPrepareNewArr(response.data.categories, "categories_id").forEach(
      (categoryItem) => {
        categoriesArr.push(categoryItem);
      },
    );

    // let tagsArr = [];

    // many2manyPrepareNewArr(response.data.tags, "tags_id").forEach((tagItem) => {
    //   tagsArr.push(tagItem);
    // });

    let faqsArr = [];

    many2manyPrepareNewArr(response.data.faqs, "faq_id", "question").forEach(
      (faqItem) => {
        faqsArr.push(faqItem);
      },
    );

    setProject((prevProject) => ({
      ...prevProject,
      translations: response.data.translations.reduce((acc, translation) => {
        acc[translation.languages_code.code] = { ...translation };
        return acc;
      }, {}),
      id: response.data.id,
      name: response.data.translations[0]?.name,
      pic: response.data.translations[0]?.pic,
      summary: response.data.translations[0]?.summary,
      desc: response.data.translations[0]?.desc,
      promo_video_url: response.data.promo_video_url,
      targets: response.data.translations[0]?.targets,
      timeline: response.data.translations[0]?.timeline,
      report_file: response.data.translations[0]?.report_file,
      cost: response.data.cost,
      donation_default_value: response.data.donation_default_value,
      donation_default_rate: response.data.donation_default_rate,
      benficial_num: response.data.benficial_num,
      // impl_country_id: {
      //   id: response.data.impl_country_id?.id,
      //   name: response.data.impl_country_id?.translations[0].name,
      // },
      lisence: response.data.lisence,
      slug: response.data.slug,
      // period: response.data.period,
      status: response.data.status,
      status_id: {
        id: response.data.status_id?.id,
        name: response.data.status_id?.translations[0].name,
      },
      zakaat_available: response.data.zakaat_available,
      urgent: response.data.urgent,
      // all_amount_required: response.data.all_amount_required,
      target_segments: tSegments,
      categories: categoriesArr,
      // tags: tagsArr,
      faqs: faqsArr,
      sequence: response.data.sequence,
      // period_type: periodTypes.find(
      //   (period_type) => period_type?.id === response.data?.period_type,
      // ),
      // mobile_pic: response.data.mobile_pic,
      web_pic: response.data.web_pic,
      donation_begin_from: response.data.donation_begin_from,
      num_of_donors_begin_from: response.data.num_of_donors_begin_from,
      date_begin: response.data.date_begin,
      date_end: response.data.date_end,
      // icon_name: response.data.icon_name,
      donation_default_values: response.data.donation_default_values,
    }));
  };

  //if id change (when click edit from projects page) get the project data
  useEffect(() => {
    if (!id) return;
    getProjects();
  }, [id]);

  useEffect(() => {
    (async () => {
      try {
        // const categoryData = await crudsService
        //   .getCategories
        //   // `&filter[_and][1][_or][1][parent_id][_nnull]=true&filter[_and][1][_or][2][id][_in]=1,22`
        //   ();

        const categoryData = await crudsService.getAllData(
          `items/categories?fields=id,translations.name,parent_id.id,parent_id.translations.name,projects.id,children.id`,
        );
        setCategories(prepareNewArr(categoryData.data));
        // const statusData = await crudsService.getItems("project_status");
        const statusData = await crudsService.getAllData(
          `items/project_status?fields=*,translations.name,projects.id`,
        );
        setAllStatus(prepareNewArr(statusData.data));

        // const countriesData = await crudsService.getItems("countries");
        const countriesData = await crudsService.getAllData(
          `items/countries?fields=*,translations.name,projects.id`,
        );
        setCountries(prepareNewArr(countriesData.data));
        // const targetSegmentsData =
        //   await crudsService.getItems("target_segment");
        const targetSegmentsData = await crudsService.getAllData(
          `items/target_segment?fields=*,translations.name,projects.id`,
        );
        setTargetSegments(prepareNewArr(targetSegmentsData.data));

        // const tagsData = await crudsService.getItems(
        //   "tags",
        //   `&filter[type][_eq]=p`
        // );
        const tagsData = await crudsService.getAllData(
          "items/tags?fields=id,translations.name&filter[type][_eq]=p",
        );
        setTags(prepareNewArr(tagsData.data));
        const faqsData = await crudsService.getAllData(
          "items/faq?fields=*,translations.question,projects.id",
        );

        setFaqs(prepareNewArr(faqsData.data, "question"));
      } catch (err) {
        console.error(err);
        return null;
      }
    })();
  }, []);

  useEffect(() => {
    if (!project) return;

    let arr = project.donation_default_values?.split("__");
    let newArr = [];
    project.donation_default_values?.length > 0 &&
      arr.forEach((element) => {
        newArr.push({ key: element });
      });
    setDonationDefaultValues(newArr);
    setInfo({
      donation_begin_from: project?.donation_begin_from,
      num_of_donors_begin_from: project?.num_of_donors_begin_from,
      date_begin: project?.date_begin,
      date_end: project?.date_end,
      // icon_name: project?.icon_name,
      cost: project?.cost,
      donation_default_value: project.donation_default_value,
      donation_default_rate: project.donation_default_rate,
      benficial_num: project?.benficial_num,
      // period: project?.period,
      lisence: project?.lisence,
      slug: project?.slug,
      sequence: project?.sequence,
      zakaat_available: project?.zakaat_available,
      urgent: project?.urgent,
      // all_amount_required: project?.all_amount_required,
      // impl_country_id: project?.impl_country_id,
      status_id: project?.status_id,
      status: project?.status,
      target_segments: project?.target_segments,
      categories: project?.categories,
      // tags: project?.tags,
      faqs: project?.faqs,
      // period_type: project?.period_type,
      donation_default_values: project.donation_default_values,
      web_pic: project.web_pic,
    });
  }, [project]);

  const changeHandler = (e, lang) => {
    if (lang) {
      setLInfo({
        translations: {
          ...linfo.translations,
          [lang]: {
            ...linfo.translations[lang],
            [e.target.name]: e.target.value,
            languages_code: lang,
          },
        },
      });
    } else {
      setInfo({
        ...info,
        [e.target.name]: e.target.value,
      });
    }
  };

  const autoSwitchChangeHandler = (name, v) => {
    setInfo({
      ...info,
      [name]: v,
    });
  };

  useEffect(() => {
    if (notification.value === true) {
      setTimeout(() => {
        setNotification({
          value: false,
          text: "",
        });
      }, 5000);
    }
  }, [notification]);

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      const { translations, ...err } = chkErrors;
      let x = { ...getEmptyFields(info, "", err) };
      let y = {
        ...getEmptyFields(linfo.translations["ar-SA"], "ar-SA", translations),
      };
      let z = {
        ...getEmptyFields(
          linfo.translations["en-US"] || {
            name: "",
            summary: "",
            desc: "",
            promo_video_url: "",
            targets: "",
            timeline: "",
            pic: null,
          },
          "en-US",
          translations,
        ),
      };
      let w = {
        ...getEmptyFields(
          linfo.translations["tr-TR"] || {
            name: "",
            summary: "",
            desc: "",
            promo_video_url: "",
            targets: "",
            timeline: "",
            pic: null,
          },
          "tr-TR",
          translations,
        ),
      };
      let obj = {
        ...x,
        ...y,
        ...z,
        ...w,
      };

      const hasErrors = Object.values(obj).some((v) => v === true);

      // if (Object.values(y).length > 0)
      //   setNotification({
      //     value: true,
      //     color: "error",
      //     text: "بيان ناقص في اللغة العربية",
      //   });
      // else if (Object.values(z).length > 0)
      //   setNotification({
      //     value: true,
      //     color: "error",
      //     text: "بيان ناقص في اللغة الإنجليزية",
      //   });
      // else if (Object.values(w).length > 0)
      //   setNotification({
      //     value: true,
      //     color: "error",
      //     text: "بيان ناقص في اللغة التركية",
      //   });

      if (!info.slug) {
        setErrors(obj);
        setNotification({
          value: true,
          color: "error",
          text: "حدث خطأ ما،الرابط مطلوب",
        });
        return; // stop
      }

      let dataNotComplete = false;
      if (hasErrors) {
        setErrors(obj);
        dataNotComplete = true;
        // return; // stop
      }

      if (info.web_pic && info.web_pic instanceof File) {
        project.web_pic && (await crudsService.removeFile(project.web_pic));
        const formData = new FormData();
        formData.append("attachment", info.web_pic);
        let img = await crudsService.uploadImage(formData);
        info.web_pic = img.id;
      } else if (info.web_pic === null) {
        delete info.web_pic;
      }

      // if (info.mobile_pic && info.mobile_pic instanceof File) {
      //   project.mobile_pic &&
      //     (await crudsService.removeFile(project.mobile_pic));
      //   const formData = new FormData();
      //   formData.append("attachment", info.mobile_pic);
      //   let img = await crudsService.uploadImage(formData);
      //   info.mobile_pic = img.id;
      // } else if (info.mobile_pic === null) {
      //   delete info.mobile_pic;
      // }
      const trns = Object.values(linfo.translations);

      for (const key in trns) {
        if (!Object.hasOwn(trns, key)) continue;

        const item = trns[key];
        item.timeline === "<p></p>" && (item.timeline = null);

        if (item.report_file && item.report_file instanceof File) {
          project.translations[item.languages_code]?.report_file &&
            (await crudsService.removeFile(
              project.translations[item.languages_code].report_file,
            ));
          const formData = new FormData();
          formData.append("attachment", item.report_file);
          let img = await crudsService.uploadImage(formData);
          item.report_file = img.id;
        } else if (item.report_file === null) {
          delete item.report_file;
        }
        if (item.pic && item.pic instanceof File) {
          project.translations[item.languages_code]?.pic &&
            (await crudsService.removeFile(
              project.translations[item.languages_code].pic,
            ));
          const formData = new FormData();
          formData.append("attachment", item.pic);
          let img = await crudsService.uploadImage(formData);
          item.pic = img.id;
        } else if (item.pic === null) {
          delete item.pic;
        }
      }

      if (id) {
        await crudsService.updateItem(`items/projects/${id}`, {
          status: dataNotComplete ? "draft" : info?.status,
          donation_begin_from: info?.donation_begin_from,
          num_of_donors_begin_from: info?.num_of_donors_begin_from,
          date_begin: info?.date_begin,
          date_end: info?.date_end,
          // icon_name: info?.icon_name,
          cost: info?.cost,
          donation_default_value: info?.donation_default_value,
          donation_default_rate: info?.donation_default_rate,
          benficial_num: info?.benficial_num,
          // period: info?.period,
          // period_type: info?.period_type.id,
          lisence: info?.lisence,
          slug: info?.slug.trim().replace(/\s+/g, "-"),
          sequence: info?.sequence,
          donation_default_values: info.donation_default_values,
          zakaat_available: info?.zakaat_available,
          urgent: info?.urgent,
          // all_amount_required: info?.all_amount_required,
          // impl_country_id: info?.impl_country_id.id,
          status_id: info?.status_id?.id,
          target_segments: info?.target_segments.map((segment) => ({
            target_segment_id: segment.id,
          })),
          // categories: info?.categories.map((cat) => ({
          //   categories_id: cat.id,
          // })),
          // tags: info?.tags.map((tag) => ({ tags_id: tag.id })),
          // mobile_pic: info?.mobile_pic,
          web_pic: info?.web_pic,
          translations: trns,
        });
      } else {
        await crudsService.createItem(`items/projects`, {
          status: dataNotComplete ? "draft" : info?.status,
          donation_begin_from: info?.donation_begin_from,
          num_of_donors_begin_from: info?.num_of_donors_begin_from,
          date_begin: info?.date_begin,
          date_end: info?.date_end,
          // icon_name: info?.icon_name,
          cost: info?.cost,
          donation_default_value: info?.donation_default_value,
          donation_default_rate: info?.donation_default_rate,
          benficial_num: info?.benficial_num,
          // period: info?.period,
          // period_type: info?.period_type.id,
          lisence: info?.lisence,
          slug: info?.slug.trim().replace(/\s+/g, "-"),
          sequence: info?.sequence,
          donation_default_values: info.donation_default_values,
          zakaat_available: info?.zakaat_available,
          urgent: info?.urgent,
          // all_amount_required: info?.all_amount_required,
          // impl_country_id: info?.impl_country_id.id,
          status_id: info?.status_id?.id,
          target_segments: info?.target_segments.map((segment) => ({
            target_segment_id: segment.id,
          })),
          categories: info?.categories?.map((cat) => ({
            categories_id: cat.id,
          })),
          // tags: info?.tags.map((tag) => ({ tags_id: tag.id })),
          faqs: info?.faqs?.map((faq) => ({ faq_id: faq.id })),
          // mobile_pic: info?.mobile_pic,
          web_pic: info?.web_pic,
          translations: trns,
        });
      }
      navigate("/projectManagement/projects", {
        state: {
          value: true,
          text: dataNotComplete ? "تم الحفظ كمسودة" : "تم الحفظ بنجاح",
        },
      });
      // setNotification({
      //   value: true,
      //   color: "success",
      //   text: dataNotComplete ? "تم الحفظ كمسودة" : "تم الحفظ بنجاح",
      // });

      // console.log(diff);
    } catch (err) {
      console.error(err.errors.message);
      setNotification({
        value: true,
        color: "error",
        text: "حدث خطأ ما،الرابط لابد ألا يتكرر الرجاء المحاولة مرة أخرى",
      });
    }
  };

  return (
    <DashboardLayout>
      <MDBox my={3}>
        <MDBox mb={6}>
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} lg={6}>
              <MDTypography variant="h4" fontWeight="medium">
                {!id ? "صفحة المشروع" : project.name}
              </MDTypography>
            </Grid>
            <Grid item xs={12} lg={6}>
              <MDBox display="flex" justifyContent="flex-end">
                <MDButton
                  variant="gradient"
                  color="info"
                  onClick={submitHandler}
                  // onClick={() => alert("خاصية الحفظ غير مفعلة حاليا")}
                >
                  {t("save")}
                </MDButton>
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
        {notification.value === true && (
          <MDAlert color={notification.color} mt="20px">
            <MDTypography variant="body2" color="white">
              {notification.text}
            </MDTypography>
          </MDAlert>
        )}
        <Grid container spacing={3}>
          <Grid item xs={12} lg={3}>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={12}>
                <Price
                  project={project}
                  changeHandler={changeHandler}
                  autoSwitchChangeHandler={autoSwitchChangeHandler}
                  setInfo={setInfo}
                  info={info}
                  setErrors={setErrors}
                  errors={errors}
                  notification={notification}
                  setNotification={setNotification}
                  donationDefaultValues={donationDefaultValues}
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <ProductImage
                  projectImage={
                    project.web_pic
                      ? `${baseUrl}assets/${project?.web_pic}`
                      : null
                  }
                  changeHandler={changeHandler}
                  imgInfo={{ name: "صورة الموقع", dimentions: "" }}
                  setInfo={setInfo}
                  info={info}
                  notification={notification}
                  setNotification={setNotification}
                  errors={errors}
                  setErrors={setErrors}
                  name="web_pic"
                />
              </Grid>
              {/* <Grid item xs={12} lg={12}>
                <ProductImage
                  projectImage={
                    project?.mobile_pic
                      ? `${baseUrl}assets/${project?.mobile_pic}`
                      : null
                  }
                  changeHandler={changeHandler}
                  imgInfo={{ name: "صورة الهاتف", dimentions: "300x300" }}
                  setInfo={setInfo}
                  info={info}
                  notification={notification}
                  setNotification={setNotification}
                  errors={errors}
                  setErrors={setErrors}
                  name="mobile_pic"
                />
              </Grid> */}
            </Grid>
          </Grid>
          <Grid item xs={12} lg={9}>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={12}>
                <LangForm
                  hasImage={true}
                  project={project}
                  changeHandler={changeHandler}
                  setInfo={setLInfo}
                  info={linfo}
                  notification={notification}
                  setNotification={setNotification}
                  errors={errors}
                  setErrors={setErrors}
                />
              </Grid>
              <Grid item xs={12} lg={12}>
                <MainInfo
                  setProject={setProject}
                  project={project}
                  categories={categories}
                  tags={tags}
                  faqs={faqs}
                  allStatus={allStatus}
                  periodTypes={periodTypes}
                  countries={countries}
                  targetSegments={targetSegments}
                  changeHandler={changeHandler}
                  autoSwitchChangeHandler={autoSwitchChangeHandler}
                  setInfo={setInfo}
                  info={info}
                  setErrors={setErrors}
                  errors={errors}
                  notification={notification}
                  setNotification={setNotification}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default EditProject;
